import { useEffect, useState, useRef } from 'react';
import { isEmpty, right } from '@Views/utils/StringUtils';

import DatePicker from '@Views/comp/DatePicker';

const EmploymentWrite2 = ({ msg, history, setPageNo, svyrEmplyPbanNo, svyrEmplySpprrDetail }: any) => {

    // 3.학력사항
    const dataItmVal1Ref: any = useRef();
    const [lectrStYmd1Date, setLectrStYmd1Date] = useState<any>();
    const [lectrEndYmd1Date, setLectrEndYmd1Date] = useState<any>();
    const schlNm1Ref: any = useRef();
    const acsubjNm1Ref: any = useRef();
    const schrSttCd1Ref: any = useRef();

    const dataItmVal2Ref: any = useRef();
    const [lectrStYmd2Date, setLectrStYmd2Date] = useState<any>();
    const [lectrEndYmd2Date, setLectrEndYmd2Date] = useState<any>();
    const schlNm2Ref: any = useRef();
    const acsubjNm2Ref: any = useRef();
    const schrSttCd2Ref: any = useRef();

    const dataItmVal3Ref: any = useRef();
    const [lectrStYmd3Date, setLectrStYmd3Date] = useState<any>();
    const [lectrEndYmd3Date, setLectrEndYmd3Date] = useState<any>();
    const schlNm3Ref: any = useRef();
    const acsubjNm3Ref: any = useRef();
    const schrSttCd3Ref: any = useRef();

    // 4.경력사항
    const [wrknStYmd1Date, setWrknStYmd1Date] = useState<any>();
    const [wrknEndYmd1Date, setWrknEndYmd1Date] = useState<any>();
    const wrkplcNm1Ref: any = useRef();
    const jbpstNm1Ref: any = useRef();
    const rspTskNm1Ref: any = useRef();

    const [wrknStYmd2Date, setWrknStYmd2Date] = useState<any>();
    const [wrknEndYmd2Date, setWrknEndYmd2Date] = useState<any>();
    const wrkplcNm2Ref: any = useRef();
    const jbpstNm2Ref: any = useRef();
    const rspTskNm2Ref: any = useRef();

    const [wrknStYmd3Date, setWrknStYmd3Date] = useState<any>();
    const [wrknEndYmd3Date, setWrknEndYmd3Date] = useState<any>();
    const wrkplcNm3Ref: any = useRef();
    const jbpstNm3Ref: any = useRef();
    const rspTskNm3Ref: any = useRef();

    // 5.자격증
    const getQlifNm1Ref: any = useRef();
    const qlifIssOrgnm1Ref: any = useRef();
    const etcCtnt1Ref: any = useRef();

    const getQlifNm2Ref: any = useRef();
    const qlifIssOrgnm2Ref: any = useRef();
    const etcCtnt2Ref: any = useRef();

    // const onChangeDataItmVal1 = () => {
    //     if (isEmpty(dataItmVal1Ref['current']['value'])) {
    //         setLectrStYmd1Date(null);
    //         setLectrEndYmd1Date(null);
    //         schlNm1Ref['current']['value'] = null;
    //         acsubjNm1Ref['current']['value'] = null;
    //     }
    // }

    // const onChangeDataItmVal2 = () => {
    //     if (isEmpty(dataItmVal2Ref['current']['value'])) {
    //         setLectrStYmd2Date(null);
    //         setLectrEndYmd2Date(null);
    //         schlNm2Ref['current']['value'] = null;
    //         acsubjNm2Ref['current']['value'] = null;
    //     }
    // }

    // const onChangeDataItmVal3 = () => {
    //     if (isEmpty(dataItmVal3Ref['current']['value'])) {
    //         setLectrStYmd3Date(null);
    //         setLectrEndYmd3Date(null);
    //         schlNm3Ref['current']['value'] = null;
    //         acsubjNm3Ref['current']['value'] = null;
    //     }
    // }

    const before = () => {
        setPageNo(0);
    }

    const next = () => {

        // 3.학력사항
        if (!isEmpty(dataItmVal1Ref['current']['value'])) {
            if (dataItmVal1Ref['current']['value'].length > 60) {
                alert("입력하신 학력사항의 구분 길이가 60자 이상입니다.");
                return;
            }
            if (schlNm1Ref['current']['value'].length > 150) {
                alert("입력하신 학력사항의 학교명 길이가 150자 이상입니다.");
                return;
            }
            if (acsubjNm1Ref['current']['value'].length > 150) {
                alert("입력하신 학력사항의 학과(전공) 길이가 150자 이상입니다.");
                return;
            }
            if (schrSttCd1Ref['current']['value'].length > 15) {
                alert("입력하신 학력사항의 졸업여부 길이가 15자 이상입니다.");
                return;
            }

            svyrEmplySpprrDetail['dataItmVal1'] = dataItmVal1Ref['current']['value'];
            if (!isEmpty(lectrStYmd1Date)) {
                svyrEmplySpprrDetail['lectrStYmd1'] = lectrStYmd1Date.getFullYear() + right("0" + (lectrStYmd1Date.getMonth() + 1), 2) + right("0" + lectrStYmd1Date.getDate(), 2);
            }
            if (!isEmpty(lectrEndYmd1Date)) {
                svyrEmplySpprrDetail['lectrEndYmd1'] = lectrEndYmd1Date.getFullYear() + right("0" + (lectrEndYmd1Date.getMonth() + 1), 2) + right("0" + lectrEndYmd1Date.getDate(), 2);
            }
            svyrEmplySpprrDetail['schlNm1'] = schlNm1Ref['current']['value'];
            svyrEmplySpprrDetail['acsubjNm1'] = acsubjNm1Ref['current']['value'];
            svyrEmplySpprrDetail['schrSttCd1'] = schrSttCd1Ref['current']['value'];
        }
        if (!isEmpty(dataItmVal2Ref['current']['value'])) {
            if (dataItmVal2Ref['current']['value'].length > 60) {
                alert("입력하신 학력사항의 구분 길이가 60자 이상입니다.");
                return;
            }
            if (schlNm2Ref['current']['value'].length > 150) {
                alert("입력하신 학력사항의 학교명 길이가 150자 이상입니다.");
                return;
            }
            if (acsubjNm2Ref['current']['value'].length > 150) {
                alert("입력하신 학력사항의 학과(전공) 길이가 150자 이상입니다.");
                return;
            }
            if (schrSttCd2Ref['current']['value'].length > 15) {
                alert("입력하신 학력사항의 졸업여부 길이가 15자 이상입니다.");
                return;
            }

            svyrEmplySpprrDetail['dataItmVal2'] = dataItmVal2Ref['current']['value'];
            if (!isEmpty(lectrStYmd2Date)) {
                svyrEmplySpprrDetail['lectrStYmd2'] = lectrStYmd2Date.getFullYear() + right("0" + (lectrStYmd2Date.getMonth() + 1), 2) + right("0" + lectrStYmd2Date.getDate(), 2);
            }
            if (!isEmpty(lectrEndYmd2Date)) {
                svyrEmplySpprrDetail['lectrEndYmd2'] = lectrEndYmd2Date.getFullYear() + right("0" + (lectrEndYmd2Date.getMonth() + 1), 2) + right("0" + lectrEndYmd2Date.getDate(), 2);
            }
            svyrEmplySpprrDetail['schlNm2'] = schlNm2Ref['current']['value'];
            svyrEmplySpprrDetail['acsubjNm2'] = acsubjNm2Ref['current']['value'];
            svyrEmplySpprrDetail['schrSttCd2'] = schrSttCd2Ref['current']['value'];
        }
        if (!isEmpty(dataItmVal3Ref['current']['value'])) {
            if (dataItmVal3Ref['current']['value'].length > 60) {
                alert("입력하신 학력사항의 구분 길이가 60자 이상입니다.");
                return;
            }
            if (schlNm3Ref['current']['value'].length > 150) {
                alert("입력하신 학력사항의 학교명 길이가 150자 이상입니다.");
                return;
            }
            if (acsubjNm3Ref['current']['value'].length > 150) {
                alert("입력하신 학력사항의 학과(전공) 길이가 150자 이상입니다.");
                return;
            }
            if (schrSttCd3Ref['current']['value'].length > 15) {
                alert("입력하신 학력사항의 졸업여부 길이가 15자 이상입니다.");
                return;
            }

            svyrEmplySpprrDetail['dataItmVal3'] = dataItmVal3Ref['current']['value'];
            if (!isEmpty(lectrStYmd3Date)) {
                svyrEmplySpprrDetail['lectrStYmd3'] = lectrStYmd3Date.getFullYear() + right("0" + (lectrStYmd3Date.getMonth() + 1), 2) + right("0" + lectrStYmd3Date.getDate(), 2);
            }
            if (!isEmpty(lectrEndYmd3Date)) {
                svyrEmplySpprrDetail['lectrEndYmd3'] = lectrEndYmd3Date.getFullYear() + right("0" + (lectrEndYmd3Date.getMonth() + 1), 2) + right("0" + lectrEndYmd3Date.getDate(), 2);
            }
            svyrEmplySpprrDetail['schlNm3'] = schlNm3Ref['current']['value'];
            svyrEmplySpprrDetail['acsubjNm3'] = acsubjNm3Ref['current']['value'];
            svyrEmplySpprrDetail['schrSttCd3'] = schrSttCd3Ref['current']['value'];
        }

        // 4.경력사항
        if (wrkplcNm1Ref['current']['value'].length > 30) {
            alert("입력하신 경력사항의 근무지 길이가 30자 이상입니다.");
            return;
        }
        if (jbpstNm1Ref['current']['value'].length > 30) {
            alert("입력하신 경력사항의 직책 길이가 30자 이상입니다.");
            return;
        }
        if (rspTskNm1Ref['current']['value'].length > 100) {
            alert("입력하신 경력사항의 담당업무 길이가 100자 이상입니다.");
            return;
        }

        if (!isEmpty(wrknStYmd1Date)) {
            svyrEmplySpprrDetail['wrknStYmd1'] = wrknStYmd1Date.getFullYear() + right("0" + (wrknStYmd1Date.getMonth() + 1), 2) + right("0" + wrknStYmd1Date.getDate(), 2);
        }
        if (!isEmpty(wrknEndYmd1Date)) {
            svyrEmplySpprrDetail['wrknEndYmd1'] = wrknEndYmd1Date.getFullYear() + right("0" + (wrknEndYmd1Date.getMonth() + 1), 2) + right("0" + wrknEndYmd1Date.getDate(), 2);
        }
        svyrEmplySpprrDetail['wrkplcNm1'] = wrkplcNm1Ref['current']['value'];
        svyrEmplySpprrDetail['jbpstNm1'] = jbpstNm1Ref['current']['value'];
        svyrEmplySpprrDetail['rspTskNm1'] = rspTskNm1Ref['current']['value'];

        if (wrkplcNm2Ref['current']['value'].length > 30) {
            alert("입력하신 경력사항의 근무지 길이가 30자 이상입니다.");
            return;
        }
        if (jbpstNm2Ref['current']['value'].length > 30) {
            alert("입력하신 경력사항의 직책 길이가 30자 이상입니다.");
            return;
        }
        if (rspTskNm2Ref['current']['value'].length > 100) {
            alert("입력하신 경력사항의 담당업무 길이가 100자 이상입니다.");
            return;
        }

        if (!isEmpty(wrknStYmd2Date)) {
            svyrEmplySpprrDetail['wrknStYmd2'] = wrknStYmd2Date.getFullYear() + right("0" + (wrknStYmd2Date.getMonth() + 1), 2) + right("0" + wrknStYmd2Date.getDate(), 2);
        }
        if (!isEmpty(wrknEndYmd2Date)) {
            svyrEmplySpprrDetail['wrknEndYmd2'] = wrknEndYmd2Date.getFullYear() + right("0" + (wrknEndYmd2Date.getMonth() + 1), 2) + right("0" + wrknEndYmd2Date.getDate(), 2);
        }
        svyrEmplySpprrDetail['wrkplcNm2'] = wrkplcNm2Ref['current']['value'];
        svyrEmplySpprrDetail['jbpstNm2'] = jbpstNm2Ref['current']['value'];
        svyrEmplySpprrDetail['rspTskNm2'] = rspTskNm2Ref['current']['value'];

        if (wrkplcNm3Ref['current']['value'].length > 30) {
            alert("입력하신 경력사항의 근무지 길이가 30자 이상입니다.");
            return;
        }
        if (jbpstNm3Ref['current']['value'].length > 30) {
            alert("입력하신 경력사항의 직책 길이가 30자 이상입니다.");
            return;
        }
        if (rspTskNm3Ref['current']['value'].length > 100) {
            alert("입력하신 경력사항의 담당업무 길이가 100자 이상입니다.");
            return;
        }

        if (!isEmpty(wrknStYmd3Date)) {
            svyrEmplySpprrDetail['wrknStYmd3'] = wrknStYmd3Date.getFullYear() + right("0" + (wrknStYmd3Date.getMonth() + 1), 2) + right("0" + wrknStYmd3Date.getDate(), 2);
        }
        if (!isEmpty(wrknEndYmd3Date)) {
            svyrEmplySpprrDetail['wrknEndYmd3'] = wrknEndYmd3Date.getFullYear() + right("0" + (wrknEndYmd3Date.getMonth() + 1), 2) + right("0" + wrknEndYmd3Date.getDate(), 2);
        }
        svyrEmplySpprrDetail['wrkplcNm3'] = wrkplcNm3Ref['current']['value'];
        svyrEmplySpprrDetail['jbpstNm3'] = jbpstNm3Ref['current']['value'];
        svyrEmplySpprrDetail['rspTskNm3'] = rspTskNm3Ref['current']['value'];

        // 5.자격증
        if (getQlifNm1Ref['current']['value'].length > 100) {
            alert("입력하신 자격증 보유현황의 자격증명 길이가 100자 이상입니다.");
            return;
        }
        if (qlifIssOrgnm1Ref['current']['value'].length > 30) {
            alert("입력하신 자격증 보유현황의 발행처 길이가 30자 이상입니다.");
            return;
        }
        if (etcCtnt1Ref['current']['value'].length > 200) {
            alert("입력하신 자격증 보유현황의 기타 길이가 200자 이상입니다.");
            return;
        }

        svyrEmplySpprrDetail['getQlifNm1'] = getQlifNm1Ref['current']['value'];
        svyrEmplySpprrDetail['qlifIssOrgnm1'] = qlifIssOrgnm1Ref['current']['value'];
        svyrEmplySpprrDetail['etcCtnt1'] = etcCtnt1Ref['current']['value'];

        if (getQlifNm2Ref['current']['value'].length > 100) {
            alert("입력하신 자격증 보유현황의 자격증명 길이가 100자 이상입니다.");
            return;
        }
        if (qlifIssOrgnm2Ref['current']['value'].length > 30) {
            alert("입력하신 자격증 보유현황의 발행처 길이가 30자 이상입니다.");
            return;
        }
        if (etcCtnt2Ref['current']['value'].length > 200) {
            alert("입력하신 자격증 보유현황의 기타 길이가 200자 이상입니다.");
            return;
        }

        svyrEmplySpprrDetail['getQlifNm2'] = getQlifNm2Ref['current']['value'];
        svyrEmplySpprrDetail['qlifIssOrgnm2'] = qlifIssOrgnm2Ref['current']['value'];
        svyrEmplySpprrDetail['etcCtnt2'] = etcCtnt2Ref['current']['value'];

        setPageNo(3);
    }

    useEffect(() => {
        if (!isEmpty(svyrEmplySpprrDetail)) {

            // 3.학력사항
            if (!isEmpty(svyrEmplySpprrDetail['dataItmVal1'])) {
                dataItmVal1Ref['current']['value'] = svyrEmplySpprrDetail['dataItmVal1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['lectrStYmd1'])) {
                const year = (svyrEmplySpprrDetail['lectrStYmd1']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['lectrStYmd1']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['lectrStYmd1']).substr(6, 2);
                setLectrStYmd1Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['lectrEndYmd1'])) {
                const year = (svyrEmplySpprrDetail['lectrEndYmd1']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['lectrEndYmd1']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['lectrEndYmd1']).substr(6, 2);
                setLectrEndYmd1Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['schlNm1'])) {
                schlNm1Ref['current']['value'] = svyrEmplySpprrDetail['schlNm1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['acsubjNm1'])) {
                acsubjNm1Ref['current']['value'] = svyrEmplySpprrDetail['acsubjNm1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['schrSttCd1'])) {
                schrSttCd1Ref['current']['value'] = svyrEmplySpprrDetail['schrSttCd1'];
            }

            if (!isEmpty(svyrEmplySpprrDetail['dataItmVal2'])) {
                dataItmVal2Ref['current']['value'] = svyrEmplySpprrDetail['dataItmVal2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['lectrStYmd2'])) {
                const year = (svyrEmplySpprrDetail['lectrStYmd2']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['lectrStYmd2']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['lectrStYmd2']).substr(6, 2);
                setLectrStYmd2Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['lectrEndYmd2'])) {
                const year = (svyrEmplySpprrDetail['lectrEndYmd2']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['lectrEndYmd2']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['lectrEndYmd2']).substr(6, 2);
                setLectrEndYmd2Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['schlNm2'])) {
                schlNm2Ref['current']['value'] = svyrEmplySpprrDetail['schlNm2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['acsubjNm2'])) {
                acsubjNm2Ref['current']['value'] = svyrEmplySpprrDetail['acsubjNm2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['schrSttCd2'])) {
                schrSttCd2Ref['current']['value'] = svyrEmplySpprrDetail['schrSttCd2'];
            }

            if (!isEmpty(svyrEmplySpprrDetail['dataItmVal3'])) {
                dataItmVal3Ref['current']['value'] = svyrEmplySpprrDetail['dataItmVal3'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['lectrStYmd3'])) {
                const year = (svyrEmplySpprrDetail['lectrStYmd3']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['lectrStYmd3']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['lectrStYmd3']).substr(6, 2);
                setLectrStYmd3Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['lectrEndYmd3'])) {
                const year = (svyrEmplySpprrDetail['lectrEndYmd3']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['lectrEndYmd3']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['lectrEndYmd3']).substr(6, 2);
                setLectrEndYmd3Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['schlNm3'])) {
                schlNm3Ref['current']['value'] = svyrEmplySpprrDetail['schlNm3'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['acsubjNm3'])) {
                acsubjNm3Ref['current']['value'] = svyrEmplySpprrDetail['acsubjNm3'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['schrSttCd3'])) {
                schrSttCd3Ref['current']['value'] = svyrEmplySpprrDetail['schrSttCd3'];
            }

            // 4.경력사항
            if (!isEmpty(svyrEmplySpprrDetail['wrknStYmd1'])) {
                const year = (svyrEmplySpprrDetail['wrknStYmd1']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['wrknStYmd1']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['wrknStYmd1']).substr(6, 2);
                setWrknStYmd1Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['wrknEndYmd1'])) {
                const year = (svyrEmplySpprrDetail['wrknEndYmd1']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['wrknEndYmd1']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['wrknEndYmd1']).substr(6, 2);
                setWrknEndYmd1Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['wrkplcNm1'])) {
                wrkplcNm1Ref['current']['value'] = svyrEmplySpprrDetail['wrkplcNm1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['jbpstNm1'])) {
                jbpstNm1Ref['current']['value'] = svyrEmplySpprrDetail['jbpstNm1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['rspTskNm1'])) {
                rspTskNm1Ref['current']['value'] = svyrEmplySpprrDetail['rspTskNm1'];
            }
            //
            if (!isEmpty(svyrEmplySpprrDetail['wrknStYmd2'])) {
                const year = (svyrEmplySpprrDetail['wrknStYmd2']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['wrknStYmd2']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['wrknStYmd2']).substr(6, 2);
                setWrknStYmd2Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['wrknEndYmd2'])) {
                const year = (svyrEmplySpprrDetail['wrknEndYmd2']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['wrknEndYmd2']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['wrknEndYmd2']).substr(6, 2);
                setWrknEndYmd2Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['wrkplcNm2'])) {
                wrkplcNm2Ref['current']['value'] = svyrEmplySpprrDetail['wrkplcNm2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['jbpstNm2'])) {
                jbpstNm2Ref['current']['value'] = svyrEmplySpprrDetail['jbpstNm2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['rspTskNm2'])) {
                rspTskNm2Ref['current']['value'] = svyrEmplySpprrDetail['rspTskNm2'];
            }
            //
            if (!isEmpty(svyrEmplySpprrDetail['wrknStYmd3'])) {
                const year = (svyrEmplySpprrDetail['wrknStYmd3']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['wrknStYmd3']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['wrknStYmd3']).substr(6, 2);
                setWrknStYmd3Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['wrknEndYmd3'])) {
                const year = (svyrEmplySpprrDetail['wrknEndYmd3']).substr(0, 4);
                const month = (svyrEmplySpprrDetail['wrknEndYmd3']).substr(4, 2) - 1;
                const day = (svyrEmplySpprrDetail['wrknEndYmd3']).substr(6, 2);
                setWrknEndYmd3Date(new Date(year, month, day));
            }
            if (!isEmpty(svyrEmplySpprrDetail['wrkplcNm3'])) {
                wrkplcNm3Ref['current']['value'] = svyrEmplySpprrDetail['wrkplcNm3'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['jbpstNm3'])) {
                jbpstNm3Ref['current']['value'] = svyrEmplySpprrDetail['jbpstNm3'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['rspTskNm3'])) {
                rspTskNm3Ref['current']['value'] = svyrEmplySpprrDetail['rspTskNm3'];
            }

            // 5.자격증 보유현황
            if (!isEmpty(svyrEmplySpprrDetail['getQlifNm1'])) {
                getQlifNm1Ref['current']['value'] = svyrEmplySpprrDetail['getQlifNm1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['qlifIssOrgnm1'])) {
                qlifIssOrgnm1Ref['current']['value'] = svyrEmplySpprrDetail['qlifIssOrgnm1'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['etcCtnt1'])) {
                etcCtnt1Ref['current']['value'] = svyrEmplySpprrDetail['etcCtnt1'];
            }
            //
            if (!isEmpty(svyrEmplySpprrDetail['getQlifNm2'])) {
                getQlifNm2Ref['current']['value'] = svyrEmplySpprrDetail['getQlifNm2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['qlifIssOrgnm2'])) {
                qlifIssOrgnm2Ref['current']['value'] = svyrEmplySpprrDetail['qlifIssOrgnm2'];
            }
            if (!isEmpty(svyrEmplySpprrDetail['etcCtnt2'])) {
                etcCtnt2Ref['current']['value'] = svyrEmplySpprrDetail['etcCtnt2'];
            }

        }

    }, [svyrEmplySpprrDetail]);

    return (
        <>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="join-step" style={{ width: "925px" }}>
                    <div className="join-step-head">
                        <div className="left">
                            <h2>지원서</h2>
                        </div>
                        <div className="right">
                            <div className="step-status">
                                <ul className="clearfix">
                                    <li className="step-li"><span className="num">1</span> <span className="step-txt">작성중</span></li>
                                    <li className="step-li active"><span className="num">2</span> <span className="step-txt">작성중</span></li>
                                    <li className="step-li"><span className="num">3</span> <span className="step-txt">작성중</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div>
                            <fieldset>
                                <h3><strong>3. 학력사항(고교이상) - 선택항목</strong></h3>
                                <div className="table-01" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                    <table>
                                        <colgroup>
                                            <col style={{ width: '15%' }} />
                                            <col style={{ width: '40%' }} />
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '13%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>구분</th>
                                                <th>기간</th>
                                                <th>학교명</th>
                                                <th>학과(전공)</th>
                                                <th>졸업여부<br />(재학/졸업/휴학)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {/* <td className="text-center">
                                                    <select className="form-control form-control-sm" style={{ width: "95%", height: "27px", borderColor: "#dddddd" }} ref={dataItmVal1Ref} onChange={onChangeDataItmVal1}>
                                                        <option value=""></option>
                                                        <option value="고등학교">고등학교</option>
                                                        <option value="대학교">대학교</option>
                                                        <option value="대학원">대학원</option>
                                                    </select>
                                                </td> */}
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={dataItmVal1Ref} maxLength={60} />
                                                </td>
                                                <td className="text-center">
                                                    <DatePicker className="date-small" value={lectrStYmd1Date} maxDate={new Date(9998, 12, 31)} onChange={setLectrStYmd1Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setLectrStYmd1Date(new Date());
                                                                setTimeout(function () { setLectrStYmd1Date(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                                                    <DatePicker className="date-small" value={lectrEndYmd1Date} maxDate={new Date(9998, 12, 31)} onChange={setLectrEndYmd1Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setLectrEndYmd1Date(new Date());
                                                                setTimeout(function () { setLectrEndYmd1Date(null) }, 100);
                                                            }
                                                        }} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={schlNm1Ref} maxLength={150} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={acsubjNm1Ref} maxLength={150} />
                                                </td>
                                                {/* <td className="text-center">
                                                    <select className="form-control form-control-sm" style={{ width: "95%", height: "27px", borderColor: "#dddddd" }} ref={schrSttCd1Ref}>
                                                        <option value="졸업">졸업</option>
                                                        <option value="재학">재학</option>
                                                        <option value="휴학">휴학</option>
                                                    </select>
                                                </td> */}
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={schrSttCd1Ref} maxLength={15} />
                                                </td>
                                            </tr>
                                            <tr>
                                                {/* <td className="text-center">
                                                    <select className="form-control form-control-sm" style={{ width: "95%", height: "27px", borderColor: "#dddddd" }} ref={dataItmVal2Ref} onChange={onChangeDataItmVal2}>
                                                        <option value=""></option>
                                                        <option value="고등학교">고등학교</option>
                                                        <option value="대학교">대학교</option>
                                                        <option value="대학원">대학원</option>
                                                    </select>
                                                </td> */}
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={dataItmVal2Ref} maxLength={60} />
                                                </td>
                                                <td className="text-center">
                                                    <DatePicker className="date-small" value={lectrStYmd2Date} maxDate={new Date(9998, 12, 31)} onChange={setLectrStYmd2Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setLectrStYmd2Date(new Date());
                                                                setTimeout(function () { setLectrStYmd2Date(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                                                    <DatePicker className="date-small" value={lectrEndYmd2Date} maxDate={new Date(9998, 12, 31)} onChange={setLectrEndYmd2Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setLectrEndYmd2Date(new Date());
                                                                setTimeout(function () { setLectrEndYmd2Date(null) }, 100);
                                                            }
                                                        }} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={schlNm2Ref} maxLength={150} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={acsubjNm2Ref} maxLength={150} />
                                                </td>
                                                {/* <td className="text-center">
                                                    <select className="form-control form-control-sm" style={{ width: "95%", height: "27px", borderColor: "#dddddd" }} ref={schrSttCd2Ref}>
                                                        <option value="졸업">졸업</option>
                                                        <option value="재학">재학</option>
                                                        <option value="휴학">휴학</option>
                                                    </select>
                                                </td> */}
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={schrSttCd2Ref} maxLength={15} />
                                                </td>
                                            </tr>
                                            <tr>
                                                {/* <td className="text-center">
                                                    <select className="form-control form-control-sm" style={{ width: "95%", height: "27px", borderColor: "#dddddd" }} ref={dataItmVal3Ref} onChange={onChangeDataItmVal3}>
                                                        <option value=""></option>
                                                        <option value="고등학교">고등학교</option>
                                                        <option value="대학교">대학교</option>
                                                        <option value="대학원">대학원</option>
                                                    </select>
                                                </td> */}
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={dataItmVal3Ref} maxLength={60} />
                                                </td>
                                                <td className="text-center">
                                                    <DatePicker className="date-small" value={lectrStYmd3Date} maxDate={new Date(9998, 12, 31)} onChange={setLectrStYmd3Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setLectrStYmd3Date(new Date());
                                                                setTimeout(function () { setLectrStYmd3Date(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                                                    <DatePicker className="date-small" value={lectrEndYmd3Date} maxDate={new Date(9998, 12, 31)} onChange={setLectrEndYmd3Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setLectrEndYmd3Date(new Date());
                                                                setTimeout(function () { setLectrEndYmd3Date(null) }, 100);
                                                            }
                                                        }} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={schlNm3Ref} maxLength={150} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={acsubjNm3Ref} maxLength={150} />
                                                </td>
                                                {/* <td className="text-center">
                                                    <select className="form-control form-control-sm" style={{ width: "95%", height: "27px", borderColor: "#dddddd" }} ref={schrSttCd3Ref}>
                                                        <option value="졸업">졸업</option>
                                                        <option value="재학">재학</option>
                                                        <option value="휴학">휴학</option>
                                                    </select>
                                                </td> */}
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={schrSttCd3Ref} maxLength={15} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <h3><strong>4. 경력사항 - 선택항목(한국은행 근무 경력 기입 가능)</strong></h3>
                                <div className="table-01" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                    <table>
                                        <colgroup>
                                            <col style={{ width: '40%' }} />
                                            <col style={{ width: '20%' }} />
                                            <col style={{ width: '17%' }} />
                                            <col style={{ width: '23%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>기간</th>
                                                <th>근무지</th>
                                                <th>직책</th>
                                                <th>담당업무<br />(100자 이내)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">
                                                    <DatePicker className="date-small" value={wrknStYmd1Date} maxDate={new Date(9998, 12, 31)} onChange={setWrknStYmd1Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setWrknStYmd1Date(new Date());
                                                                setTimeout(function () { setWrknStYmd1Date(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                                                    <DatePicker className="date-small" value={wrknEndYmd1Date} maxDate={new Date(9998, 12, 31)} onChange={setWrknEndYmd1Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setWrknEndYmd1Date(new Date());
                                                                setTimeout(function () { setWrknEndYmd1Date(null) }, 100);
                                                            }
                                                        }} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={wrkplcNm1Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={jbpstNm1Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={rspTskNm1Ref} maxLength={100} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">
                                                    <DatePicker className="date-small" value={wrknStYmd2Date} maxDate={new Date(9998, 12, 31)} onChange={setWrknStYmd2Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setWrknStYmd2Date(new Date());
                                                                setTimeout(function () { setWrknStYmd2Date(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                                                    <DatePicker className="date-small" value={wrknEndYmd2Date} maxDate={new Date(9998, 12, 31)} onChange={setWrknEndYmd2Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setWrknEndYmd2Date(new Date());
                                                                setTimeout(function () { setWrknEndYmd2Date(null) }, 100);
                                                            }
                                                        }} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={wrkplcNm2Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={jbpstNm2Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={rspTskNm2Ref} maxLength={100} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">
                                                    <DatePicker className="date-small" value={wrknStYmd3Date} maxDate={new Date(9998, 12, 31)} onChange={setWrknStYmd3Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setWrknStYmd3Date(new Date());
                                                                setTimeout(function () { setWrknStYmd3Date(null) }, 100);
                                                            }
                                                        }} />
                                                    <span style={{ alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                                                    <DatePicker className="date-small" value={wrknEndYmd3Date} maxDate={new Date(9998, 12, 31)} onChange={setWrknEndYmd3Date} format="yyyy.MM.dd" maxDetail={'month'}
                                                        onCalendarClose={() => {
                                                            let invalidEle: any = document.querySelector('input:invalid');
                                                            if (invalidEle) {
                                                                if (invalidEle['name'] === 'month') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '월 사이를 입력해주세요.');
                                                                }
                                                                if (invalidEle['name'] === 'day') {
                                                                    alert(invalidEle['min'] + '~' + invalidEle['max'] + '일 사이를 입력해주세요.');
                                                                }
                                                                setWrknEndYmd3Date(new Date());
                                                                setTimeout(function () { setWrknEndYmd3Date(null) }, 100);
                                                            }
                                                        }} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={wrkplcNm3Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={jbpstNm3Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={rspTskNm3Ref} maxLength={100} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <h3><strong>5. 자격증 보유현황 - 선택항목</strong></h3>
                                <div className="table-01" style={{ paddingTop: "13px", paddingBottom: "13px" }}>
                                    <table>
                                        <colgroup>
                                            <col style={{ width: '37%' }} />
                                            <col style={{ width: '33%' }} />
                                            <col style={{ width: '30%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>자격증명</th>
                                                <th>발행처</th>
                                                <th>기타</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={getQlifNm1Ref} maxLength={100} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={qlifIssOrgnm1Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={etcCtnt1Ref} maxLength={200} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={getQlifNm2Ref} maxLength={100} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={qlifIssOrgnm2Ref} maxLength={30} />
                                                </td>
                                                <td className="text-center">
                                                    <input className="form-control" type="text" style={{ width: "95%", height: "27px", borderColor: "#dddddd", borderWidth: "1px", borderStyle: "solid" }} ref={etcCtnt2Ref} maxLength={200} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p className="input-guide text-important" style={{ fontSize: "14px" }}>※ 상기 학력,경력사항 및 자격증 보유현황은 통계조사보조원으로서 직무수행능력을 심사하는데 활용될 수 있음</p>
                            </fieldset>
                        </div>

                        <div className="btn-group btn-130">
                            <button type="button" className="btn btn-popup negative" onClick={before}>이전</button>
                            <button type="button" className="btn btn-popup positive" onClick={next}>다음</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default EmploymentWrite2;